<template>
  <a-layout-content>
    <div class="body-nest">
      <a-table
        bordered
        row-key="ID"
        size="middle"
        :columns="columns"
        :data-source="datarow"
        :pagination="pagination"
      >
        <template slot="title">
          <a-row>
            <a-col :span="6" style="line-height: 30px">{{
              this.input.name
            }}</a-col>
            <a-col style="float: right">
              <a href="javascript:;" @click="editfield(null)">
                <a-button type="primary"
                  ><a-icon type="plus"></a-icon>表单字段</a-button
                >
              </a>
              <router-link :to="'/activielist'">
                <a-button type="primary"
                  ><a-icon type="rollback"></a-icon>返回</a-button
                >
              </router-link>
            </a-col>
          </a-row>
        </template>
        <template slot="Type" slot-scope="text, record">
          <a-tag v-if="record.Type == '1'" color="cyan">字串</a-tag>
          <a-tag v-else-if="record.Type == '2'" color="cyan">数字</a-tag>
          <a-tag v-else-if="record.Type == '3'" color="cyan">手机格式</a-tag>
          <a-tag v-else-if="record.Type == '4'" color="cyan">时间格式</a-tag>
        </template>
        <template slot="Operation" slot-scope="text, record">
          <a-tooltip title="编辑">
            <a href="javascript:;" @click="editfield(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;&nbsp;
          <a-tooltip title="删除">
            <a @click="deletefield(record)">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="字段编辑" @ok="Save">
      <a-form-model
        :model="formModel"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="字段名称">
          <a-input
            v-model="formModel.InputName"
            type="text"
            autocomplete="off"
          />
        </a-form-model-item>
        <a-form-model-item label="类型">
          <a-select v-model="formModel.Type">
            <a-select-option value="1">字串</a-select-option>
            <a-select-option value="2">数字</a-select-option>
            <a-select-option value="3">手机格式</a-select-option>
            <a-select-option value="4">时间格式</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="formModel.Sort" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
export default {
  data() {
    return {
      //------table --------
      columns: IninTable(),
      datarow: [],
      pagination: {
        total: 0,
        showTotal: (total) => `共 ${total} 条`,
      },
      //--------------------
      input: {
        id: 0,
        name: "",
      },
      visible: false, //弹框状态
      formModel: { Type: "1", Sort: 1 }, // 弹框字段
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      savetype: "add",
    };
  },
  methods: {
    query() {
      let _this = this;
      let params = {
        ID: this.input.id,
      };

      this.axios
        .post("/promotions/getpromotionsinputslist", params)
        .then((res) => {
          _this.datarow = res.data;
          _this.pagination.total = res.total;
        });
    },
    //编辑
    editfield(record) {
      if (record === null) {
        this.savetype = "add";
        this.formModel = { Type: "1", Sort: 1 };
      } else {
        this.savetype = "edit";
        this.formModel = { ...record };
        this.formModel.Type = "" + record.Type;
      }
      this.visible = true;
    },
    //删除
    deletefield(record) {
      let _this = this;

      let params = {
        ID: record.ID,
        type: 3,
      };
      this.axios
        .post("/promotions/deletepromotionsinputs", params)
        .then((res) => {
          if (res.data) {
            _this.$message.success("删除成功");
            _this.query();
          }
        });
    },
    //保存
    Save() {
      let _this = this;

      let params = {
        AID: this.input.id,
        Property: this.formModel.Type,
        Sort: this.formModel.Sort,
        Name: this.formModel.InputName,
        type: 1,
      };
      if (this.savetype === "edit") {
        params.type = 2;
        params.ID = this.formModel.ID;
      }

      let url =
        this.action === "add"
          ? "/promotions/addpromotionsinputs"
          : "/promotions/editpromotionsinputs";

      this.axios
        .post("/promotions/editpromotionsinputs", params)
        .then((res) => {
          if (res.data) {
            _this.$message.success("操作成功");
            _this.query();
          }
        });
    },
  },
  created() {
    this.input.id = this.$route.params.id;
    this.input.name = this.$route.params.activiesName;
    this.query();
  },
  watch: {
    $route(to, from) {
      if (to.name === "formconfiguration") {
        this.input.id = this.$route.params.id;
        this.input.name = this.$route.params.activiesName;
        this.query();
      }
      // if (from.name === "formconfiguration") {
      //   this.input.id = this.$route.params.id;
      //   this.activiesName = this.$route.params.activiesName;
      //   console.log(this.input.id);
      // }
    },
  },
};

const IninTable = function IninTable() {
  var header = [];
  header.push({ title: "编号", align: "center", width: 80, dataIndex: "ID" });
  header.push({
    title: "排序",
    align: "center",
    width: 80,
    sorter: (a, b) => a.Sort - b.Sort,
    dataIndex: "Sort",
  });
  header.push({
    title: "字段名称",
    align: "center",
    dataIndex: "InputName",
  });
  header.push({
    title: "字段类型",
    align: "center",
    dataIndex: "Type",
    scopedSlots: { customRender: "Type" },
  });
  header.push({
    title: "操作",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "Operation" },
  });
  return header;
};
</script>

<style>
.clearline {
  border-top: solid #acc0d8 1px;
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/promotions/formconfiguration.vue